<script lang="ts">
    import { Button, Col } from "sveltestrap";
    import { Update, WelcometothevihoFamily, Wellcome } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import UserIncome from "./UserIncome.svelte";
</script>

<Col xl="12" md="6" class="box-col-6 des-xl-50">
    <Card cardProps="profile-greeting " cardBodyprops="text-center pt-0">
        <div slot="customheader">
            <div class="header-top">
                <div class="setting-list bg-primary position-unset">
                  <ul class="list-unstyled setting-option">
                    <li>
                      <div class="setting-white"><i class="icon-settings"></i></div>
                    </li>
                  </ul>
                </div>
            </div>
        </div>
        <div slot="contentbody">
            <h3 class="font-light">{Wellcome}</h3>
            <p>{WelcometothevihoFamily}</p>
            <Button class="btn btn-light">{Update}</Button>
        </div>
        <div class="confetti">
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
            <div class="confetti-piece" />
        </div>
    </Card>
</Col>
<UserIncome />
